<template>
    <div class="player" style="width: 100%;">
        <div class="container" STYLE="min-height: 200px !important;">
            <!--header>
                <h1>{{lesson_info.lesson_name}}<span></span></h1>
            </header-->
            <section>
                <div id="audio-slideshow" class="audio-slideshow" :data-audio="lesson_info.media_url"
                     :data-audio-duration="lesson_info.media_duration">
                    <div class="audio-slides">
                        <img v-for="(image_url,index) in lesson_info.images_url_list" :key="index" :src="image_url"
                             :data-slide-time="lesson_info.images_slide_time_list[index] ">
                    </div>
                    <div class="audio-control-interface">
                        <div class="play-pause-container">
                            <a href="javascript:;" class="audio-play" tabindex="1">Play</a>
                            <a href="javascript:;" class="audio-pause" tabindex="1">Pause</a>
                        </div>
                        <div class="time-container">
                            <span class="play-time"></span> / <span class="total-time"></span>
                        </div>
                        <div class="timeline">
                            <div class="timeline-controls"></div>
                            <div class="playhead"></div>
                        </div>
                        <div class="jplayer"></div>
                    </div>
                    <div class="tab_audios_div">
                        <a style="display: none;" href="javascript:void(0)" class="tab_audios_a tab_audios_a_left">
                            <span class="tab_audios_button tab_audios_button_left"></span>
                        </a>
                        <a style="display: none" href="javascript:void(0)" class="tab_audios_a tab_audios_a_right">
                            <span class="tab_audios_button tab_audios_button_right"></span>
                        </a>
                        <a href="javascript:void(0)" class="tab_audios_a tab_audios_a_play audio-play">
                            <span class="tab_audios_button tab_audios_button_play"></span>
                        </a>
                    </div>
                </div>
            </section>
        </div>

    </div>
</template>

<script type="text/javascript">
    import '@/assets/js/jquery.min.js'
    import '@/assets/js/jquery.jplayer.js'
    import '@/assets/js/jquery.audioslideshow.js'
    import learningApi from '@/api/learning/learning.js'

    import {mapState, mapActions} from 'vuex'

    export default {
        computed: {
            ...mapState({
                lesson_info: state => state.learning.lesson_info
            })
        },
        methods: {
            ...mapActions({
                get_and_change_lesson_info: 'learning/get_and_change_lesson_info',
            })
        },
          created: function () {

        },
        watch: {
            lesson_info: function () {
                if (this.lesson_info.lesson_progress) {
                    this.$nextTick(function () {
                        $('#audio-slideshow').audioSlideshow(this.lesson_info.lesson_progress);
                    })
                } else {
                    this.$nextTick(function () {
                        $('#audio-slideshow').audioSlideshow();
                    })
                }

            }
        },
        mounted() {
            console.log('jPlayer prepare...');
            console.log('jPlayer OK.');

            let courseId = this.$route.params.id;
            let lessonId = this.$route.query.id;
            let args = {'courseId': courseId, 'lessonId': lessonId};
            this.get_and_change_lesson_info(args);
        }
    }


</script>
<style type="text/css" scoped>
    @import '../../../assets/css/jquery.audioslideshow.css';

    .player {
        float: left;
    }

    .container {
        padding: 0;
    }

    .marker span img {
        display: none !important;
    }

    .audio-slideshow {
        width: 100% !important;
    }

    @media screen and (max-width: 1000px) {
        .container > header h1 {
            font-size: 12px !important;
            font-weight: bold;
            line-height: 12px !important;
        }

        .container {
            min-height: 220px;
        }

        /*已经在控件中设置了自动高度*/
        /*.audio-slideshow {*/
        /*    height: 210px !important;*/
        /*}*/
    }

    .tab_audios_div {
        display: block;
    }

    /* 左右切换按钮 */


    .tab_audios_a {
        position: absolute;
        display: block;
        height: 80px;
        width: 80px;
        top: 48%;
        bottom: 50%;
        border-radius: 40px;
        background: black;
        opacity: .3;
        text-align: center;
        line-height: 74px;
        z-index: 5;
    }

    .tab_audios_a:hover {
        opacity: .3;
    }

    .tab_audios_button {
        height: 60px;
        width: 40px;
        font-size: 40px;
        color: #fff;
        /*text-align: center;*/
    }

    .tab_audios_a_left {
        left: 5%;
        transform: translate(0, -50%);
    }

    .tab_audios_a_play {
        left: 45%;
        opacity: .8;
        transform: translate(0, -50%);
    }

    .tab_audios_button_left:after {
        content: "<";
    }

    .tab_audios_button_play:after {
        content: "▷";
        margin-left: 4px;
        font-size: 45px;
    }

    .tab_audios_a_right {
        right: 5%;
        transform: translate(0, -50%);
    }

    .tab_audios_button_right:before {
        content: ">";
    }

    @media screen and (max-width: 1000px) {
        .tab_audios_a {
            height: 40px;
            width: 40px;
            top: 48%;
            line-height: 1.4;
        }

        .tab_audios_button {
            font-size: 25px;
        }

        .tab_audios_button_play:after {
            font-size: 30px !important;
        }
    }
</style>